import { render, staticRenderFns } from "./CaseProceeding.vue?vue&type=template&id=b3046a22"
import script from "./CaseProceeding.vue?vue&type=script&lang=js"
export * from "./CaseProceeding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports